import React from 'react';
import { createUseStyles } from 'react-jss';
import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import colors from '@packages/core/styles/colors';
import { Button, Icon } from '@packages/ui/shared';

const useStyles = createUseStyles({
    tooltip: {
        minWidth: 50,
        marginTop: 5,
        '& .tooltip-inner': {
            backgroundColor: colors.brandSecondary,
            borderRadius: 4,
            fontSize: '13px',
            fontWeight: 400,
        },
    },
});

interface CidCvnDownloadButtonProps {
    isDisabled: boolean;
    isLoading: boolean;
    onPress: () => void;
}

export function CidCvnDownloadButton({ isDisabled, isLoading, onPress }: CidCvnDownloadButtonProps) {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <OverlayTrigger
            placement="bottom"
            overlay={
                <Tooltip className={classes.tooltip} id="download-tool-tip">
                    {t('buttons:download')}
                </Tooltip>
            }
        >
            <Button
                data-testid="download-button"
                variant="ghost-blue"
                disabled={isDisabled}
                isLoading={isLoading}
                onPress={onPress}
            >
                <Icon name="sync-down" color="blueOne" />
            </Button>
        </OverlayTrigger>
    );
}
